export function formatDateForBackend(date: Date | number = new Date()) {
  return new Date(date).toISOString().split("T")[0]
}

export function convertDateToYyyyMmDd(date = "") {
  const isAlreadyCorrectFormat = /^\d{4}-\d{2}-\d{2}$/.test(date)
  if (isAlreadyCorrectFormat) {
    return date
  }

  return date.split("-").reverse().join("-")
}
